import { ReactElement } from 'react';

import { useFormController } from '@dreryk/react-common';

import { ScheduleOnlyVisibilityPreferenceField } from '../../../shared/preferences/ScheduleOnlyVisibilityPreferenceField/ScheduleOnlyVisibilityPreferenceField';
import { useScheduleOnlyVisibilityPreferenceState } from '../../../shared/preferences/preferences.storage';

import {
   HealthcareLocationTimetablePreferencesFormBean,
   HealthcareLocationTimetablePreferencesFormController,
} from './HealthcareLocationTimetablePreferencesForm.types';
import { StyledHealthcareLocationTimetablePreferencesForm } from './HealthcareLocationTimetablePreferencesForm.styled';

type SpecialistTimetablePreferencesFormChildrenRenderProps = {
   handleSubmit: HealthcareLocationTimetablePreferencesFormController['handleSubmit'];
};

type HealthcareLocationTimetablePreferencesFormProps = {
   children: (renderProps: SpecialistTimetablePreferencesFormChildrenRenderProps) => ReactElement;
};

export const HealthcareLocationTimetablePreferencesForm = (
   props: HealthcareLocationTimetablePreferencesFormProps
): ReactElement => {
   const [preferScheduleOnlyVisible] = useScheduleOnlyVisibilityPreferenceState();
   const { register, handleSubmit } = useFormController<HealthcareLocationTimetablePreferencesFormBean>({
      preferScheduleOnlyVisible: preferScheduleOnlyVisible,
   });

   return (
      <StyledHealthcareLocationTimetablePreferencesForm direction={'column'} gap={'12px'}>
         <ScheduleOnlyVisibilityPreferenceField register={register} />

         {props.children({ handleSubmit: handleSubmit })}
      </StyledHealthcareLocationTimetablePreferencesForm>
   );
};
